const CONSTANTS = {
  production: {
    manifest_id: process.env.NEXT_PUBLIC_URL || '',
    sitename: 'Intranet Fortesec',
    shortname: 'Intranet',
    cache_prefix: 'intranet',
    email_domain: process.env.AZURE_AD_DOMAIN || '',
  },
  staging: {
    manifest_id: process.env.NEXT_PUBLIC_URL || '',
    sitename: 'Intranet Fortesec (STAGING)',
    shortname: 'Intranet Staging',
    cache_prefix: 'intranet',
    email_domain: process.env.AZURE_AD_DOMAIN || '',
  },
  local: {
    manifest_id: process.env.NEXT_PUBLIC_URL || '',
    sitename: 'Intranet Fortesec (LOCAL)',
    shortname: 'Intranet Local',
    cache_prefix: 'intranet',
    email_domain: process.env.AZURE_AD_DOMAIN || '',
  }
};

// Public envs in build time
export const NEXT_PUBLIC_ADMIN_URL = process.env.NEXT_PUBLIC_ADMIN_URL || '';
export const NEXT_PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL || '';
export const NEXT_PUBLIC_PAYLOAD_URL = process.env.NEXT_PUBLIC_PAYLOAD_URL || '';
export const NEXT_PUBLIC_URL = process.env.NEXT_PUBLIC_URL || '';
export const NEXT_PUBLIC_BLOG_URL = process.env.NEXT_PUBLIC_BLOG_URL || '';
export const NEXT_PUBLIC_ENVIRONMENT = process.env.NEXT_PUBLIC_ENVIRONMENT || '';
export const NEXT_PUBLIC_APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION || '';
export const NEXT_PUBLIC_REMOVE_FEATURE_VALEU = process.env.NEXT_PUBLIC_REMOVE_FEATURE_VALEU || '';

// Helpers
export const SECONDS_IN_MILLISECONDS = 1000;
export const MINUTES_IN_MILLISECONDS = 60 * SECONDS_IN_MILLISECONDS;
export const HOURS_IN_MILLISECONDS = 60 * MINUTES_IN_MILLISECONDS;
export const DAYS_IN_MILLISECONDS = 24 * HOURS_IN_MILLISECONDS;

export const MINUTES_IN_SECONDS = 60;
export const HOURS_IN_SECONDS = 60 * MINUTES_IN_SECONDS;
export const DAYS_IN_SECONDS = 24 * HOURS_IN_SECONDS;

export function isDebugging() {
  return getEnvironment() === 'local';
}

export function isDeveloping() {
  return isDebugging() || getEnvironment() === 'staging';
}

export function getEnvironment() {
  return process?.env?.ENVIRONMENT || NEXT_PUBLIC_ENVIRONMENT || 'local';
}

export function getVersion() {
  return process?.env?.NEXT_PUBLIC_APP_VERSION || NEXT_PUBLIC_APP_VERSION || '1.0.0';
}

export function getConstant(name, defaultValue = '') {
  const env = getEnvironment();
  const value = CONSTANTS[env][name] || CONSTANTS.production[name];

  return typeof value === 'undefined' ? defaultValue : value;
}
